import * as bi from 'react-bootstrap-icons';
import { Button, Checkbox, Flex, Input, Message, TextContent } from 'components';
import { useState } from 'react';
import { isValidEmail } from '../../../../helpers';
import { useToggle } from 'common/hooks';
import { PublicDocumentsService } from 'common/services';
import { Link } from 'react-router';

interface IProps {
  onRegisterClick: (email: string) => void;
}

function FrameEmail(props: IProps) {
  const [email, setEmail] = useState<string>('');
  const [policyAccepted, switchPolicyAccepted] = useToggle(false);

  const isEmailValid = isValidEmail(email);
  const isError = email.length > 0 && !isEmailValid;
  const isAllowed = email.length > 0 && isEmailValid && policyAccepted;

  const handleRegisterClick = () => {
    if (isAllowed) {
      props.onRegisterClick(email.trim());
    }
  };

  const handleEmailKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && isAllowed) {
      props.onRegisterClick(email.trim());
    }
  };

  return (
    <Flex
      direction='column'
      gap={20}
    >
      <TextContent align='center'>Для регистрации в сервисе укажите ваш адрес электронной почты</TextContent>
      <Flex
        direction='column'
        gap={10}
      >
        <Input
          type='email'
          icon={<bi.Envelope />}
          placeholder='address@mail.ru'
          label='E-Mail адрес'
          value={email}
          onChange={setEmail}
          onKeyDown={handleEmailKeyDown}
          error={isError}
        />
        <Message type='info'>
          На указанную почту будет направлен код подтверждения, который нужно будет ввести далее
        </Message>
      </Flex>

      {isError && (
        <Message
          type='error'
          title='Ошибка ввода'
        >
          E-Mail введен неверно
        </Message>
      )}

      <Flex
        direction='column'
        gap={5}
      >
        <Checkbox
          checked={policyAccepted}
          onChange={switchPolicyAccepted}
        >
          Даю своё{' '}
          <Link
            target='_blank'
            rel='noopener noreferrer'
            to={PublicDocumentsService.getInstance().consentHref()}
          >
            согласие на обработку предоставленных мной персональных данных
          </Link>{' '}
          в соответствии с{' '}
          <Link
            to={PublicDocumentsService.getInstance().privacyPolicyHref()}
            target='_blank'
            rel='noopener noreferrer'
          >
            политикой обработки персональных данных
          </Link>
        </Checkbox>

        <Button
          color='red'
          disabled={!isAllowed}
          onClick={handleRegisterClick}
        >
          Регистрация
        </Button>
      </Flex>
    </Flex>
  );
}

export default FrameEmail;
